import {enumType} from 'common/enumType';

const buildType = (
   id: string,
   display: string,
   name: string,
   success: boolean,
   warning: boolean,
   failure: boolean
) => ({
   id,
   display,
   name,
   success,
   warning,
   failure,
});

export const NotificationType = enumType({
   NOTIFY_ON_SUCCESS: buildType('NOTIFY_ON_SUCCESS', 'Success', 'Success', true, false, false),
   NOTIFY_ON_WARNING: buildType('NOTIFY_ON_WARNING', 'Warning', 'Warning', false, true, false),
   NOTIFY_ON_FAILURE: buildType('NOTIFY_ON_FAILURE', 'Failure', 'Failure', false, false, true),
   NOTIFY_ON_SUCCESS_OR_WARNING: buildType(
      'NOTIFY_ON_SUCCESS_OR_WARNING',
      'SuccessWarning',
      'Success and Warning',
      true,
      true,
      false
   ),
   NOTIFY_ON_SUCCESS_OR_FAILURE: buildType(
      'NOTIFY_ON_SUCCESS_OR_FAILURE',
      'SuccessFailure',
      'Success and Failure',
      true,
      false,
      true
   ),
   NOTIFY_ON_WARNING_OR_FAILURE: buildType(
      'NOTIFY_ON_WARNING_OR_FAILURE',
      'WarningFailure',
      'Warning and Failure',
      false,
      true,
      true
   ),
   NOTIFY_ALWAYS: buildType('NOTIFY_ALWAYS', 'Always', 'All Jobs', true, true, true),
});
